// Importa lo SCSS del popup — Vite lo compila in css/popup.css
import './popup.scss';

/**
 * Pixell Popup — Frontend JS v1.1
 * Cookie, sessione, apertura ritardata, dev mode, chiusura,
 * iniezione campo "fonte" in CF7.
 */
( function () {
    'use strict';

    var cfg = window.pixellPopupConfig || {
        delay:        2000,
        cookieDays:   7,
        cookieName:   'pixell_popup_dismissed',
        devMode:      false,
        sessionOnly:  false,
        fonteEnabled: false,
        fonteValue:   'popup',
    };

    /* ── Cookie utils ─────────────────────────────────────── */
    function setCookie( name, value, days ) {
        var expires = '';
        if ( days ) {
            var d = new Date();
            d.setTime( d.getTime() + days * 24 * 60 * 60 * 1000 );
            expires = '; expires=' + d.toUTCString();
        }
        document.cookie = name + '=' + encodeURIComponent( value ) + expires + '; path=/; SameSite=Lax';
    }

    function getCookie( name ) {
        var match = document.cookie.match( new RegExp( '(?:^|; )' + name + '=([^;]*)' ) );
        return match ? decodeURIComponent( match[1] ) : null;
    }

    /* ── Session utils ────────────────────────────────────── */
    // Cookie di sessione (senza "expires"): condiviso fra tutte le tab,
    // si azzera solo alla chiusura del browser. sessionStorage invece è
    // isolato per tab, quindi il popup ricomparirebbe ad ogni nuova tab.
    function setSession( name ) {
        setCookie( name, '1', 0 );
    }

    function getSession( name ) {
        return getCookie( name );
    }

    /* ── Controlla se già mostrato ────────────────────────── */
    function alreadyShown() {
        if ( cfg.sessionOnly ) {
            return !! getSession( cfg.cookieName );
        }
        return !! getCookie( cfg.cookieName );
    }

    /* ── Segna come mostrato ──────────────────────────────── */
    function markShown() {
        if ( cfg.devMode ) return;
        if ( cfg.sessionOnly ) {
            setSession( cfg.cookieName );
        } else if ( cfg.cookieDays > 0 ) {
            setCookie( cfg.cookieName, '1', cfg.cookieDays );
        }
    }

    /* ── Inietta campo "fonte" in tutti i form CF7 presenti ─ */
    function injectFonte() {
        if ( ! cfg.fonteEnabled ) return;
        var forms = document.querySelectorAll( '.wpcf7-form' );
        forms.forEach( function ( form ) {
            // Evita di aggiungere più volte
            if ( form.querySelector( 'input[name="pixell-fonte"]' ) ) return;
            var input = document.createElement( 'input' );
            input.type  = 'hidden';
            input.name  = 'pixell-fonte';
            input.value = cfg.fonteValue;
            form.appendChild( input );
        } );
    }

    /* ── Open / Close ─────────────────────────────────────── */
    function openPopup( overlay ) {
        overlay.removeAttribute( 'hidden' );
        overlay.setAttribute( 'aria-hidden', 'false' );
        document.body.style.overflow = 'hidden';
        var closeBtn = overlay.querySelector( '.pixell-close' );
        if ( closeBtn ) setTimeout( function () { closeBtn.focus(); }, 50 );
    }

    function closePopup( overlay ) {
        overlay.setAttribute( 'hidden', '' );
        overlay.setAttribute( 'aria-hidden', 'true' );
        document.body.style.overflow = '';
        markShown();
    }

    /* ── Init ─────────────────────────────────────────────── */
    function init() {
        var overlay = document.getElementById( 'pixell-popup-overlay' );
        if ( ! overlay ) return;

        if ( ! cfg.devMode && alreadyShown() ) return;

        setTimeout( function () {
            openPopup( overlay );
            markShown();   // ← segna subito: l'utente potrebbe uscire senza chiudere
        }, cfg.delay );

        // Chiudi: pulsante ✕
        var closeBtn = document.getElementById( 'pixell-popup-close' );
        if ( closeBtn ) {
            closeBtn.addEventListener( 'click', function () { closePopup( overlay ); } );
        }

        // Chiudi: click sull'overlay
        overlay.addEventListener( 'click', function ( e ) {
            if ( e.target === overlay ) closePopup( overlay );
        } );

        // Chiudi: tasto Escape
        document.addEventListener( 'keydown', function ( e ) {
            if ( ( e.key === 'Escape' || e.key === 'Esc' ) && ! overlay.hasAttribute( 'hidden' ) ) {
                closePopup( overlay );
            }
        } );

        // CTA: inietta "fonte" nei form, poi chiudi il popup
        var ctaBtn = overlay.querySelector( '.pixell-cta__btn' );
        if ( ctaBtn ) {
            ctaBtn.addEventListener( 'click', function ( e ) {
                var href = ctaBtn.getAttribute( 'href' ) || '';
                if ( href === '#' || href === '' ) {
                    e.preventDefault();
                }
                injectFonte();   // ← inietta il campo solo quando l'utente clicca CTA
                closePopup( overlay );
            } );
        }
    }

    if ( document.readyState === 'loading' ) {
        document.addEventListener( 'DOMContentLoaded', init );
    } else {
        init();
    }

} )();
